<template>
    <div class="escalatorChart">
        <el-select style="position: absolute;left: 0px;top:-10px" v-model="curPosition" placeholder="请选择"
            @change="selectPosition">
            <el-option v-for="item, index in $store.state.curEscalatorSensorList" :key="item.position"
                :label="item.position" :value="item.position">
            </el-option>
        </el-select>
        <vibrationCart :title="title" ref="vibrationCart"></vibrationCart>
    </div>
</template>
    
<script>
import vibrationCart from '../../../components/vibration-chart.vue';

export default {
    props: ['chartData', 'title'],
    components: {
        vibrationCart
    },
    data() {
        return {
            curPosition: ''
        };
    },
    mounted() {
    },
    destroyed() {
    },
    computed: {

    },
    methods: {
        selectPosition() {
            //上半区location = 1 下半区location = 2
            let dataY = []
            let legend = []

            if (this.curPosition == '上半区') {
                if (this.chartData.chartDataY) {
                    dataY = this.chartData.chartDataY.filter((item) => this.getTopOrBottomList(1).includes(item.name))
                    legend = this.getTopOrBottomList(1)
                }
            } else if (this.curPosition == '下半区') {
                if (this.chartData.chartDataY) {
                    dataY = this.chartData.chartDataY.filter((item) => this.getTopOrBottomList(2).includes(item.name))
                    legend = this.getTopOrBottomList(2)
                }
            } else {
                if (this.chartData.chartDataY) {
                    dataY = this.chartData.chartDataY.filter((item) => this.curPosition == item.name)
                    legend.push(this.curPosition)
                }
            }
            this.$refs.vibrationCart.setData({ chartDataX: this.chartData.chartDataX, chartDataY: dataY, legendData: legend });
        },
        getTopOrBottomList(location) {
            return this.$store.state.curEscalatorSensorList
                .filter((item) => item.location == location)
                .map((item) => item.position);
        }
    },
    watch: {

    },
};
</script>
    
<style lang="less" scoped>
.escalatorChart {
    position: relative;

    /deep/.el-select .el-input .el-input__inner {
        background: transparent !important;
        border: none !important;
        width: 130px;
        color: #B4B4B4 !important;
    }
}
</style>
    
      


// WEBPACK FOOTER //
// src/pages/home/realTime/escalator-chart.vue